import React, { useEffect, useState } from "react"

import { styled } from "@mui/material/styles"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { SegmentedItem } from "./types/SegmentedItem"
import { MuiIcon } from "../MuiIcon"

interface IProps {
  items: SegmentedItem[],
  defaultSelected?: string,
  onChange?: (id: string) => void,
  width?: string
}

export const SegmentedButton = ({ items, defaultSelected, ...props }: IProps) => {
  const [checked, setChecked] = useState<string>(defaultSelected || items[0]?.id)
  const { i18n } = useTranslations()

  useEffect(() => {
    if (defaultSelected) setChecked(defaultSelected)
  }, [defaultSelected])

  return <Wrapper>
    {
      items.map(({ title, titleKey, id }, index) =>
        <StyledItem
          sx={{ width: props.width || "inherit" }}
          className={checked === id ? "checked" : ""}
          key={index}
          onClick={() => {
            setChecked(id)
            props.onChange?.(id)
          }}>

          <CheckedIcon className={checked === id ? "checked" : ""} />

          {titleKey ? i18n(titleKey) : title}
        </StyledItem>
      )
    }
  </Wrapper>
}

const Wrapper = styled("div")({
  display: "flex",
  margin: "4px 0"
})

const StyledItem = styled("div")({
  display: "flex",
  height: "40px",
  minWidth: "120px",
  border: "1px solid #79747E",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: "#1A1A1A",
  fontWeight: 600,
  lineHeight: "20px",
  fontSize: "14px",
  textTransform: "capitalize",

  "&.checked": {
    background: "#D9F2E0"
  },

  "&:first-of-type": {
    borderRadius: "100px 0 0 100px"
  },

  "&:not(:first-of-type)": {
    borderLeft: "none"
  },

  "&:last-of-type": {
    borderRadius: "0 100px 100px 0"
  }
})

const CheckedIcon = styled(MuiIcon.Check)({
  fontSize: "18px",
  opacity: 0,
  position: "absolute",

  "&.checked": {
    opacity: 1,
    position: "relative",
    marginRight: "8px",
    transition: "all .2s ease-in"
  }
})
